export default __webpack_public_path__ + "static/media/apple-play.c0232950.png";